import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../utils/translations';

const STRATEGY_TITLES = {
  tyr: 'TYR',
  ares: 'ARES',
  ascalafo: 'ASCÁLAFO',
  deimos: 'DEIMOS',
  fobos: 'FOBOS',
  bes: 'BES',
  janus: 'JANUS',
  hraesvelgr: 'HRÆSVELGR',
  eos: 'EOS',
  artemis: 'ARTEMIS',
  helios: 'HELIOS',
  hyperion: 'HYPERION',
  horai: 'HORAI',
  theia: 'THEIA',
  astraeus: 'ASTRAEUS',
  phaethon: 'PHAETHON',
  hemera: 'HEMERA',
  selene: 'SELENE',
  asteria: 'ASTERIA',
  aether: 'AETHER',
  heimdall: 'HEIMDALL',
  metis: 'METIS',
};

function titleForPath(pathname, language) {
  const strategy = pathname.match(/^\/strategies\/([^/]+)/);
  if (strategy) {
    const name = STRATEGY_TITLES[strategy[1]] || strategy[1].toUpperCase();
    return t('pageTitle.strategy', language, { name });
  }

  const routes = [
    [/^\/$/, 'pageTitle.home'],
    [/^\/strategies\/?$/, 'pageTitle.strategies'],
    [/^\/performance/, 'pageTitle.performance'],
    [/^\/reports/, 'pageTitle.reports'],
    [/^\/research/, 'pageTitle.research'],
    [/^\/portfolio/, 'pageTitle.portfolio'],
    [/^\/about/, 'pageTitle.about'],
    [/^\/contact/, 'pageTitle.contact'],
    [/^\/institutional/, 'pageTitle.institutional'],
    [/^\/login/, 'pageTitle.login'],
    [/^\/account/, 'pageTitle.account'],
    [/^\/privacy/, 'pageTitle.privacy'],
    [/^\/terms/, 'pageTitle.terms'],
    [/^\/legal/, 'pageTitle.legal'],
    [/^\/quant-lab/, 'pageTitle.quantLab'],
    [/^\/yggdrasil/, 'pageTitle.engine'],
    [/^\/terminal\/app/, 'pageTitle.terminal'],
    [/^\/terminal/, 'pageTitle.terminal'],
    [/^\/auth\/reset/, 'pageTitle.reset'],
    [/^\/auth\/callback/, 'pageTitle.auth'],
  ];

  const match = routes.find(([re]) => re.test(pathname));
  return t(match ? match[1] : 'pageTitle.home', language);
}

export default function DocumentTitle() {
  const { pathname } = useLocation();
  const { language } = useLanguage();

  useEffect(() => {
    document.title = titleForPath(pathname, language);
    const desc = t('meta.description', language);
    const node = document.querySelector('meta[name="description"]');
    if (node && desc) node.setAttribute('content', desc);
  }, [pathname, language]);

  return null;
}
